/* unplugin-vue-components disabled */const { ref, computed, onMounted, onUpdated, nextTick } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-2438101c"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "sence-desktop-wrap" };
const _hoisted_2 = { class: "tree-scene-wrap" };
const _hoisted_3 = { class: "main-scene" };
const _hoisted_4 = { class: "basic-panel-wrap" };
const index_vue_1 = tslib_1.__importDefault(require("@/components/DeviceTree/index.vue"));
const index_vue_2 = tslib_1.__importDefault(require("@/components/MainScene/index.vue"));
const BasicPanel_vue_1 = tslib_1.__importDefault(require("./components/BasicPanel.vue"));
const work_1 = require("@/store/modules/work");
const project_1 = require("@/service/project");
const model_1 = require("@/model");
const one_message_1 = require("@/utils/one_message");
const router_1 = tslib_1.__importDefault(require("@/router"));
exports.default = (0, vue_1.defineComponent)(Object.assign({
    name: 'design'
}, { __name: 'index', emits: ['openProject'], setup(__props, { expose: __expose, emit: __emit }) {
        const store = (0, work_1.useWork)();
        const openPanel = ref(true);
        const scene = ref(index_vue_2.default);
        const curPage = computed(() => router_1.default.currentRoute.value.name);
        const emit = __emit;
        function reset() {
            scene.value.cleanUp();
        }
        function handlePanel() {
            openPanel.value = !openPanel.value;
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 200);
        }
        onMounted(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (curPage.value === 'design' && !model_1.Project.current()) {
                try {
                    yield project_1.ProjectService.current().openLastOpenProject();
                }
                catch (e) {
                    one_message_1.oneMessage.error(e.message);
                    emit('openProject');
                }
            }
        }));
        onUpdated(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            nextTick(() => {
                window.dispatchEvent(new Event('resize'));
            });
            if (curPage.value === 'design' && !model_1.Project.current()) {
                try {
                    yield project_1.ProjectService.current().openLastOpenProject();
                }
                catch (e) {
                    one_message_1.oneMessage.warning(e.message);
                    emit('openProject');
                }
            }
        }));
        __expose({
            reset
        });
        return (_ctx, _cache) => {
            const _component_svg_icon = (0, vue_2.resolveComponent)("svg-icon");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_el_affix = (0, vue_2.resolveComponent)("el-affix");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(index_vue_1.default),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(index_vue_2.default, {
                            ref_key: "scene",
                            ref: scene
                        }, null, 512)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)({ 'planing-setting': (0, vue_2.unref)(openPanel), 'close-panel': !(0, vue_2.unref)(openPanel) })
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)(BasicPanel_vue_1.default)
                    ]),
                    (0, vue_2.createVNode)(_component_el_affix, { style: { "position": "relative", "left": "-35px", "top": "-50%" } }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_icon, {
                                size: "30px",
                                style: { "width": "30px" },
                                onClick: handlePanel
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_svg_icon, {
                                        "icon-class": (0, vue_2.unref)(openPanel) ? 'angle-double-right' : 'angle-double-left'
                                    }, null, 8, ["icon-class"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ], 2)
            ]));
        };
    } }));
